var staticStrUndefined = require('./staticStrUndefined')

var helperCreateInTypeof = require('./helperCreateInTypeof')

/**
  * 判断是否Undefined
  *
  * @param {Object} obj 对象
  * @return {Boolean}
  */
var isUndefined = helperCreateInTypeof(staticStrUndefined)

module.exports = isUndefined



//////////////////
// WEBPACK FOOTER
// ./~/.store/xe-utils@3.7.9/~/xe-utils/isUndefined.js
// module id = 72
// module chunks = 75